import { mailIsValid } from './functions'

export const shouldSendSecondFactor = (
    enabled: boolean | undefined,
    type: string | undefined,
    destination: string,
    alreadySent: boolean,
): boolean => {
    if (!enabled || alreadySent || !type) {
        return false
    }
    if (type === 'mail') {
        return mailIsValid(destination)
    }
    return type === 'phone'
}
